import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export function MembersHarvestPage() {
  return <div className="min-h-screen bg-white" data-id="element-1051">
      {/* Header */}
      <Header variant="solid" data-id="element-1052" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-1053">
        <div className="max-w-4xl mx-auto" data-id="element-1054">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-1055">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-1056">
              News & Events
            </a>
            <span className="mx-2" data-id="element-1057">/</span>
            <span className="text-neutral-900" data-id="element-1058">
              Peterson House's First Members Harvest Experience
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-1059">
            Peterson House's First Members Harvest Experience
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-1060">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/3-cheeseplate-1.12.25.jpg" alt="Members Harvest Experience" className="w-full h-full object-cover" data-id="element-1061" />
          </div>

          {/* Content */}
          <article className="max-w-none" data-id="element-1062">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1063">
              There's something truly special about harvesting grapes by
              hand—the crisp morning air, the golden glow of the vineyard, and
              the excitement of knowing these very grapes will soon transform
              into our flagship bubbles, the Pinot Noir Chardonnay Meunier. This
              year, Peterson House invited our cherished members to be part of
              this magic, and what an unforgettable experience it was!
            </p>

            {/* Morning Arrival */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-1064">
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1065">
                Guests arrived early, greeted by the sight of dewy vines and a
                welcoming glass of bubbles—because at Peterson House, we believe
                every great day starts with sparkling wine.
              </p>
            </div>

            {/* Harvesting */}
            <div className="mb-8" data-id="element-1066">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1067">
                The Harvest
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1068">
                With secateurs in hand, our members moved through the vineyard,
                carefully selecting the ripest Chardonnay grapes destined for
                our next vintage (and carefully working around the eight-legged
                friends). Laughter and conversation filled the air as they
                worked side by side, embracing the rhythm of the harvest. After
                baskets overflowed with golden fruit, it was time to trade in
                work gloves for wine glasses and indulge in the well-earned two
                course breakfast crafted by the talented chefs in our very own
                Restaurant Cuvée! The perfect reward for the morning's efforts.
              </p>
            </div>

            {/* Breakfast & Talk */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-1069">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1070">
                Breakfast & Bubbleologist Talk
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-4" data-id="element-1071">
                Following our indulgent breakfast our members enjoyed a
                fascinating talk from our expert bubbleologist Geoff who shared
                the sparkling journey from grape to glass! An incredible
                hands-on experience that brought them closer to the heart of
                Peterson House.
              </p>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1072">
                A wonderful day was had by all, now our winemakers are off to
                make the perfect bottle of bubbles for these members to truly
                enjoy their hard work!
              </p>
            </div>

            {/* Future Events */}
            <div className="mb-8" data-id="element-1073">
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1074">
                If you missed this year's harvest, don't worry—there's always
                more to come. Stay connected with us for future exclusive member
                events, behind-the-scenes experiences, and, of course, plenty of
                sparkling moments. Here's to many more vintages together!
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-brand-pink/5 p-8 my-12 text-center" data-id="element-1075">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1076">
                Join Our Wine Club
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-6" data-id="element-1077">
                Become a Peterson House member and enjoy exclusive access to
                events like our harvest experience, behind-the-scenes tours, and
                special tastings throughout the year.
              </p>
              <a href="/wine-club" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1078">
                Explore Wine Club
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1079" />
              </a>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-1080">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1081">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1082" />
    </div>;
}